// src/pages/StatusPage.js
import React from 'react'
import { Box, Container, Typography, Card, CardContent, Stack, Chip, Divider } from '@mui/material'
import { SignalCellularAlt as StatusIcon, CheckCircle as OkIcon } from '@mui/icons-material'
import { useLanguage } from '../contexts/LanguageContext'

const StatusPage = () => {
    const { t, lang } = useLanguage()
    const isFr = lang === 'fr'
    const tt = (key, enFallback, frFallback) => t(key, null, isFr ? frFallback : enFallback)

    return (
        <Box sx={{ py: { xs: 5, md: 7 } }}>
            <Container maxWidth="md">
                <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 1 }}>
                    <StatusIcon />
                    <Typography variant="h4" sx={{ fontWeight: 950, color: 'white' }}>
                        {tt('status.title', 'Status', 'Statut')}
                    </Typography>
                    <Chip
                        label={tt('status.badge', 'All systems operational', 'Tous les systèmes opérationnels')}
                        size="small"
                    />
                </Stack>

                <Typography sx={{ color: 'rgba(255,255,255,0.72)', mb: 3 }}>
                    {tt('status.subtitle', 'Service health for MojoPayr.', 'État des services pour MojoPayr.')}
                </Typography>

                <Card
                    sx={{
                        borderRadius: 6,
                        bgcolor: 'rgba(15,23,42,0.72)',
                        border: '1px solid rgba(255,255,255,0.10)',
                        overflow: 'visible', // ✅ prevents any weird clipping
                    }}
                >
                    {/* ✅ padding fix here */}
                    <CardContent sx={{ p: { xs: 3, md: 3.5 } }}>
                        <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 1 }}>
                            <OkIcon sx={{ color: '#22c55e' }} />
                            <Typography sx={{ color: 'white', fontWeight: 950 }}>
                                {tt('status.coreServices', 'Core services', 'Services principaux')}
                            </Typography>
                        </Stack>

                        <Divider sx={{ borderColor: 'rgba(255,255,255,0.10)', my: 2 }} />

                        <Row name={tt('status.row.login', 'Login', 'Connexion')} status={tt('status.operational', 'Operational', 'Opérationnel')} />
                        <Row name={tt('status.row.wallet', 'Wallet', 'Portefeuille')} status={tt('status.operational', 'Operational', 'Opérationnel')} />
                        <Row name={tt('status.row.send', 'Send Money', 'Envoyer de l’argent')} status={tt('status.operational', 'Operational', 'Opérationnel')} />
                        <Row name={tt('status.row.transactions', 'Transactions', 'Transactions')} status={tt('status.operational', 'Operational', 'Opérationnel')} />
                        <Row name={tt('status.row.donations', 'Donations', 'Dons')} status={tt('status.operational', 'Operational', 'Opérationnel')} />
                        <Row name={tt('status.row.contributions', 'Contributions', 'Contributions')} status={tt('status.operational', 'Operational', 'Opérationnel')} />

                        <Divider sx={{ borderColor: 'rgba(255,255,255,0.10)', my: 2 }} />

                        <Typography sx={{ color: 'rgba(255,255,255,0.60)', fontSize: 13 }}>
                            {tt(
                                'status.note',
                                'Service status is shown from the current MojoPayr configuration.',
                                'Le statut du service est affiche a partir de la configuration MojoPayr actuelle.'
                            )}
                        </Typography>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    )
}

const Row = ({ name, status }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1.1 }}>
        <Typography sx={{ color: 'rgba(255,255,255,0.72)', fontWeight: 800 }}>{name}</Typography>
        <Typography sx={{ color: 'white', fontWeight: 900 }}>{status}</Typography>
    </Box>
)

export default StatusPage

